<!--
✅ Loading
✅ List
-->
<template>
  <div>
    <div v-if="loading">
      <b-row>
        <b-col cols="12" xl="4">
          <b-skeleton-img></b-skeleton-img>
        </b-col>
        <b-col cols="12" xl="4">
          <b-skeleton-img></b-skeleton-img>
        </b-col>
        <b-col cols="12" xl="4">
          <b-skeleton-img></b-skeleton-img>
        </b-col>
      </b-row>
    </div>
    <div v-if="!loading">
      <div v-for="(c, index) in cards" :key="index">
        <b-row v-if="index == 0 || index % 3 == 0">
          <b-col cols="12" xl="4" v-if="cards[index]">
            <b-jumbotron
              :header="(cards[index]['rate'] || '...') + '%'"
              :lead="cards[index]['name']"
            >
              <div class="w-100 text-right">
                <b-avatar button icon="arrow-right"></b-avatar>
              </div>
            </b-jumbotron>
          </b-col>
          <b-col cols="12" xl="4" v-if="cards[index + 1]">
            <b-jumbotron
              :header="(cards[index + 1]['rate'] || '...') + '%'"
              :lead="cards[index + 1]['name']"
            >
              <div class="w-100 text-right">
                <b-avatar button icon="arrow-right" disabled></b-avatar>
              </div>
            </b-jumbotron>
          </b-col>
          <b-col cols="12" xl="4" v-if="cards[index + 2]">
            <b-jumbotron
              :header="(cards[index + 2]['rate'] || '...') + '%'"
              :lead="cards[index + 2]['name']"
            >
              <div class="w-100 text-right">
                <b-avatar button icon="arrow-right" disabled></b-avatar>
              </div>
            </b-jumbotron>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      cards: [
        { id: 0, rate: 15, name: "Walmart" },
        { id: 0, name: "Coming Soon" },
      ],
    };
  },
  methods: {},
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  },
};
</script>